module.exports = __webpack_public_path__ + "static/media/logo.2892752b.svg";